"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "worksheets",
    path: "/worksheets",
    component: "WorksheetList"
});
let WorksheetList = class WorksheetList extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('integro_api/list_worksheet');
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                },
                b_2248226175642056_columns: [{
                        field: "number",
                        name: this.$fn.pgettext("Worksheets", "Number"),
                        type: "command",
                        width: "200px",
                        formatter: {
                            name: "routeLink",
                            to: "worksheet",
                            params: {
                                id: "id",
                            },
                        },
                    },
                    {
                        field: "status",
                        name: this.$fn.pgettext("Worksheets", "Status"),
                        width: "150px",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "gettext",
                                    context: "WorksheetStatus",
                                    conversion: "StartCase",
                                    filterInput: true,
                                },
                                {
                                    name: "statusDot",
                                },
                            ],
                        },
                    },
                    {
                        field: "worksheet_date",
                        name: this.$fn.pgettext("Worksheets", "Date"),
                        type: "date",
                    },
                    {
                        field: "description",
                        width: "200px",
                        name: this.$fn.pgettext("Worksheets", "Description"),
                    },
                    {
                        field: "rental_name",
                        name: this.$fn.pgettext("Worksheets", "Rental"),
                        type: "command",
                        formatter: {
                            name: "routeLink",
                            to: "rental",
                            navigateOnIconClick: true,
                            params: {
                                id: "rental_id",
                            },
                        },
                    },
                    {
                        field: "company_name",
                        name: this.$fn.pgettext("Worksheets", "Company"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "company_id",
                            },
                        },
                    },
                    {
                        field: "client_name",
                        width: "200px",
                        name: this.$fn.pgettext("Worksheets", "Client"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "client_id",
                            },
                        },
                    },
                    {
                        field: "contractor_name",
                        width: "200px",
                        name: this.$fn.pgettext("Worksheets", "Contractor"),
                        formatter: {
                            name: "routeLink",
                            to: "company",
                            navigateOnIconClick: true,
                            params: {
                                id: "contractor_id",
                            },
                        },
                    },
                    {
                        field: "created_at",
                        name: this.$fn.pgettext("BrowserColumn", "Create time"),
                        formatter: "datetime",
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Worksheets"),
                icon: this.$config.worksheet.icon,
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_5754_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_5756_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_showModal_5758_getActionArgs($event) {
        return {
            name: "Worksheet",
            props: {
                size: "lg",
            },
        };
    }
    async evh_6466705138206980_click(event, scope) {
        return await this.actions.evh_6466705138206980_click.executeFromDOM(this, event, scope);
    }
    async act_8320016629450276_reloadSlickgrid_5762_getActionArgs($event) {
        return {
            grid: "worksheets",
        };
    }
    async act_8320016629450276_request_5760_getActionArgs($event) {
        return {
            operation: "delete_worksheets",
            data: { worksheets: this.selectedItems.map(p => p.id) },
        };
    }
    async evh_8320016629450276_click(event, scope) {
        return await this.actions.evh_8320016629450276_click.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_5754 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_5754_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_5753 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_5754,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_5753],
        });
        const act_2248226175642056_setData_5756 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_5756_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_5755 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_5756,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_5755],
        });
        const act_6466705138206980_showModal_5758 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_6466705138206980_showModal_5758_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_click_5757 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_showModal_5758,
            event: "click",
            displayName: "showModal",
        });
        const evh_6466705138206980_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_click_5757],
        });
        const act_8320016629450276_reloadSlickgrid_5762 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_8320016629450276_reloadSlickgrid_5762_getActionArgs,
            events: [],
        });
        const evh_8320016629450276_success_5761 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_reloadSlickgrid_5762,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_8320016629450276_request_5760 = new core_1.actions.RequestAction({
            actionArgs: this.act_8320016629450276_request_5760_getActionArgs,
            displayName: "deleteItems",
            events: [evh_8320016629450276_success_5761],
        });
        const evh_8320016629450276_click_5759 = new core_1.actions.EventHandlerImpl({
            action: act_8320016629450276_request_5760,
            event: "click",
            displayName: "deleteItems",
        });
        const evh_8320016629450276_click = new core_1.actions.EventHandlerGroup({
            handlers: [evh_8320016629450276_click_5759],
        });
        return {
            act_7315092382398562_closeModal_5754,
            evh_7315092382398562_close_5753,
            evh_7315092382398562_close,
            act_2248226175642056_setData_5756,
            evh_2248226175642056_selectedRowsChanged_5755,
            evh_2248226175642056_selectedRowsChanged,
            act_6466705138206980_showModal_5758,
            evh_6466705138206980_click_5757,
            evh_6466705138206980_click,
            act_8320016629450276_reloadSlickgrid_5762,
            evh_8320016629450276_success_5761,
            act_8320016629450276_request_5760,
            evh_8320016629450276_click_5759,
            evh_8320016629450276_click,
            deleteItems: act_8320016629450276_request_5760,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WorksheetList.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WorksheetList.prototype, "onSize", null);
WorksheetList = __decorate([
    (0, vue_property_decorator_1.Component)()
], WorksheetList);
exports.default = WorksheetList;
vue_property_decorator_1.Vue.component("WorksheetList", WorksheetList);
